module.exports = __webpack_public_path__ + "img/img_5.3b57957b.png";